import { Skeleton } from '@/components/ui/skeleton';
import ContentHeader from '@/components/messaging/ContentHeader';
import { Box, Flex, Grid, HStack, VStack } from '@chakra-ui/react';
import React from 'react';

const SentBatchDetailSkeleton: React.FC = () => {
  return (
    <Flex direction="column" h="full" overflow="hidden">
      <ContentHeader>
        <HStack gap={2} w="full">
          <Skeleton height="28px" width="28px" rounded="md" />
          <Skeleton height="18px" width="200px" />
        </HStack>
      </ContentHeader>

      <Box flex={1} overflowY="auto" px={5} py={4}>
        <VStack align="stretch" gap={5} maxW="7xl" mx="auto" w="full">
          {/* Stats skeleton */}
          <Grid
            templateColumns="repeat(3, 1fr)"
            borderWidth="1px"
            borderColor="gray.200"
            rounded="lg"
            overflow="hidden"
            bg="white"
          >
            {[0, 1, 2].map((i) => (
              <Box
                key={i}
                p={3}
                textAlign="center"
                borderLeftWidth={i > 0 ? '1px' : '0'}
                borderColor="gray.200"
              >
                <Skeleton height="12px" width="60px" mx="auto" mb={2} />
                <Skeleton height="28px" width="40px" mx="auto" />
              </Box>
            ))}
          </Grid>

          {/* Email preview skeleton */}
          <Box borderWidth="1px" borderColor="gray.200" rounded="lg" overflow="hidden" bg="white">
            <VStack align="stretch" gap={2} px={4} py={3}>
              {[0, 1, 2].map((i) => (
                <HStack key={i} gap={2}>
                  <Skeleton height="14px" width="50px" />
                  <Skeleton height="14px" width={`${120 + i * 40}px`} />
                </HStack>
              ))}
            </VStack>
            <Box borderTopWidth="1px" borderColor="gray.200" px={4} py={3}>
              <Skeleton height="14px" width="90%" mb={2} />
              <Skeleton height="14px" width="70%" mb={2} />
              <Skeleton height="14px" width="50%" />
            </Box>
          </Box>

          {/* Table skeleton */}
          <Box>
            <Skeleton height="12px" width="100px" mb={2} />
            {Array.from({ length: 3 }).map((_, i) => (
              <HStack key={i} py={3} borderBottomWidth="1px" borderColor="gray.100" gap={3}>
                <Skeleton height="24px" width="24px" rounded="full" />
                <Skeleton height="14px" width="100px" />
                <Skeleton height="14px" width="120px" />
                <Skeleton height="20px" width="50px" rounded="md" />
                <Box flex={1} />
                <Skeleton height="12px" width="130px" />
              </HStack>
            ))}
          </Box>
        </VStack>
      </Box>
    </Flex>
  );
};

export default SentBatchDetailSkeleton;
